import React, { useState } from "react";
import AddTagModal from "./AddTagModal";

export function FloatRight({ viewStatus, onChange }) {
  const [addModalOpen, setAddModalOpen] = useState(false);

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <div className="btn-group btn-group-sm" role="group">
          <button
            type="button"
            className={`btn ${viewStatus === "listView" ? "btn-primary" : "btn-outline-secondary"}`}
            onClick={() => onChange("listView")}
            title="List View"
          >
            <i className="la la-list" />
          </button>
          <button
            type="button"
            className={`btn ${viewStatus === "gridView" ? "btn-primary" : "btn-outline-secondary"}`}
            onClick={() => onChange("gridView")}
            title="Grid View"
          >
            <i className="la la-th-large" />
          </button>
        </div>

        <button
          className="btn btn-primary btn-sm d-flex align-items-center gap-1 shadow-sm"
          onClick={() => setAddModalOpen(true)}
        >
          <i className="la la-plus" style={{ fontSize: "16px" }} />
          <span>Add Tag</span>
        </button>
      </div>

      {addModalOpen && (
        <AddTagModal
          visible={addModalOpen}
          onCancel={() => setAddModalOpen(false)}
        />
      )}
    </>
  );
}

export default FloatRight;
